<template>
  <Layout title="Reset Your Password">
    <ResetForm v-on:form-submitted="submitData" />
  </Layout>
</template>

<script>
import ResetForm from "@/components/Forms/ResetForm.vue";
import Layout from "@/Layout/NotAuthenticated/Layout.vue";

export default {
  name: "ResetPassword",
  data() {
    return {
      user: null,
      loading: false,
    };
  },
  components: {
    Layout,
    ResetForm,
  },
  created() {},
};
</script>
